export class Paginator {

    paginateCallback = ()=>{}
    ALL_COUNT = 0
    filter
    isInit=false
    sectionTitle
    paginateUrl=''

    constructor(sectionTitle, limit = 10, grouped = false, filter=null) {
        this.section = $(`.data-view.${sectionTitle}`);
        this.pageNumberStatus = 1;
        this.VISIBLE_COUNT = limit;
        this.grouped = grouped;
        this.sectionTitle = sectionTitle;
        this.PAGINATOR_CONTAINER = $(`.paginator.${sectionTitle}`);
        this.PAGINATE_PAGE_INPUT = this.PAGINATOR_CONTAINER.find('.paginator-number');
        if(filter!=null)
            this.attachFilter(filter)
        else
            this.isInit=true
        this.checkStatus();
    }

    attachFilter(filter){
        this.filter = filter
        this.paginateCallback = filter.main.bind(filter)
        if(filter.allCount)
            this.ALL_COUNT = filter.allCount
        $(document).on('filter_completed',(e)=>{
            if(e.detail.source == this.filter && typeof e.detail?.allCount === 'number'){
                if(!this.isInit)
                    this.isInit = true
                if(this.ALL_COUNT != e.detail.allCount)
                    this.resetAllCount(e.detail.allCount)
                if(this == e.detail.source.paginator && !this.section.hasClass('d-none'))
                    this.showPaginator()
                else if(this.ALL_COUNT<=this.VISIBLE_COUNT)
                    this.hidePaginator()
            }
        })
    }

    standartPaginateCallback(page,limit){
        $.ajax({
            url: `${paginateUrl}/paginate`,
            method: "GET",
            data: params,
            success: (response) => {
                if(response?.allCount && response?.view){
                    const element = document.createElement('div');
                    element.innerHTML = response.view;
                    this.section.html(element.firstChild.innerHTML);
                    if (this.ALL_COUNT != response.allCount)
                        this.resetAllCount(response.allCount)
                    if (!this.section.hasClass('d-none'))
                        this.showPaginator()
                    else if (this.ALL_COUNT <= this.VISIBLE_COUNT)
                        this.hidePaginator()
                }
            },
            error:(err)=>{
                console.error(err)
            }
        })
    }

    resetAllCount(count){
        this.ALL_COUNT = count
        this.PAGINATE_PAGE_INPUT.val(1)
        this.pageNumberStatus = 1
        this.setPaginationStat()
    }

    getPaginateInterval(){
        const pageNumber = this.getPaginatedPageNumber();
        const start = this.VISIBLE_COUNT * (pageNumber - 1) + 1;
        const end = start + this.VISIBLE_COUNT - 1;
        return [start, end];
    }

    setPaginationStat(){
        let [start, end] = this.getPaginateInterval();
        if (end > this.ALL_COUNT) end = this.ALL_COUNT;
        this.PAGINATOR_CONTAINER.find('.paginator-status').text(`Showing ${start} to ${end} of ${this.ALL_COUNT} entities`);
    }

    getPaginatedPageNumber(){
        return parseInt(this.PAGINATE_PAGE_INPUT.val());
    }
    getSectionEntities() {
        return this.section.find('table').not('.d-sm-none').find('tr.data-row');
    }
    checkStatus() {
        if (this.PAGINATOR_CONTAINER[0]) {
            this.PAGINATE_PAGE_INPUT.val(this.pageNumberStatus);
            this.paginatorListners();
            this.showPaginator();
        }
    }
    maxPageNumber() {
        return Math.ceil(this.ALL_COUNT / this.VISIBLE_COUNT);
    }
    checkBorders() {
        const pageNumber = this.getPaginatedPageNumber();
        if (pageNumber > this.maxPageNumber()) this.pageNumberStatus = this.maxPageNumber();
        if (pageNumber < 1) this.pageNumberStatus = 1;
        this.PAGINATE_PAGE_INPUT.val(this.pageNumberStatus ?? 1);
    }
    async paginateSection() {
        this.checkBorders();
        const allCount = await this.paginateCallback({page:this.getPaginatedPageNumber(), limit:this.VISIBLE_COUNT})
        if(typeof allCount === 'number' && allCount != this.ALL_COUNT){
            this.resetAllCount(allCount)
        }
        if(!this.isInit)
            this.isInit = true
        this.setPaginationStat();
        this.showPaginator();
        //if (this.grouped) this.checkGroups();
    }
    paginatorListners() {
        this.PAGINATE_PAGE_INPUT.on('input', this.paginateSection);
        this.PAGINATOR_CONTAINER.find('.paginator-controller .paginator-controll').off('click').on('click', (e) => {
            const controll = $(e.target);
            if (controll.hasClass('right')) {
                this.PAGINATE_PAGE_INPUT.val(++this.pageNumberStatus);
                this.paginateSection();
            }
            if (controll.hasClass('left')) {
                if (this.pageNumberStatus > 1) {
                    this.PAGINATE_PAGE_INPUT.val(--this.pageNumberStatus);
                    this.paginateSection();
                }
            }
        });
    }

    showPaginator() {
        if (this.ALL_COUNT > this.VISIBLE_COUNT || !this.isInit) {
            this.PAGINATOR_CONTAINER.removeClass('d-none');
            this.PAGINATOR_CONTAINER.addClass('d-flex');
        } else {
            this.PAGINATOR_CONTAINER.removeClass('d-flex');
            this.PAGINATOR_CONTAINER.addClass('d-none');
        }
        this.setPaginationStat()
    }

    hidePaginator() {
        this.PAGINATOR_CONTAINER.removeClass('d-flex').addClass('d-none');
    }

    /*checkGroups() {
        const mainGroupRows = $(`tr[data-group-main`).not('.is_warning');
        for (let mainGroupRow of mainGroupRows) {
            const groupId = $(mainGroupRow).data('group-main');
            const visibleGroupItems = $(`tr.data-row[data-group-id=${groupId}]`).not('.d-none').not('.is_warning');
            visibleGroupItems.length ? $(mainGroupRow).removeClass('d-none') : $(mainGroupRow).addClass('d-none');
        }
        const mainWarningGroupRows = $(`tr.is_warning[data-group-main]`);
        for (let mainGroupRow of mainWarningGroupRows) {
            const groupId = $(mainGroupRow).data('group-main');
            const visibleGroupItems = $(`tr.data-row[data-group-id=${groupId}].is_warning`).not('.d-none');
            visibleGroupItems.length ? $(mainGroupRow).removeClass('d-none') : $(mainGroupRow).addClass('d-none');
        }
    }*/
}
